<template>
  <div class="product-list-legend-fi">
    {{ $dict.get('product-Catalog.Block-Labels.Descendant-Variants.Legend') }}
    <span class="product-list-legend-fi__item">
      <icon-fi icon="check" /> =
      <span class="product-list-legend-fi__item-value">
        {{ $dict.get('product-Catalog.Block-Labels.Descendant-Variants.Permission-Available') }}
      </span>
    </span>
    <span class="product-list-legend-fi__item">
      <span class="product-list-legend-fi__item-key">—</span> =
      <span class="product-list-legend-fi__item-value">
        {{ $dict.get('product-Catalog.Block-Labels.Descendant-Variants.Permission-not-Available') }}
      </span>
    </span>
  </div>
</template>

<script>
import { IconFi } from 'atoms';

export default {
  name: 'ProductListLegendFi',
  components: {
    IconFi,
  },
};
</script>

<style scoped src="./product-list-legend-fi" />
